import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import React from 'react';
import { GenerateRow, LoadingRow } from './GenerateRow';

export const TableComponent = ({
  limit,
  orderType,
  data,
  loading,
  page,
  handleChangePage,
}) => {
  return (
    <Box sx={{ paddingTop: 3 }}>
      <TableContainer component={Paper} sx={{ borderRadius: 0, padding: '2%' }}>
        <Table>
          <TableHead>
            <TableRow>
              {orderType.table.map((item, index) => (
                <TableCell key={index} align="center" sx={{ borderBottom: 1 }}>
                  {item.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading &&
              Array.from({ length: 10 }).map((_, index) => (
                <LoadingRow table={orderType.table} key={index} />
              ))}
            {!loading &&
              data?.orders?.map(
                (order) =>
                  order && (
                    <GenerateRow
                      key={order?._id}
                      table={orderType.table}
                      order={order}
                    />
                  )
              )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[limit]}
        component="div"
        count={data.totalCount || 0}
        rowsPerPage={limit}
        page={page}
        onPageChange={handleChangePage}
      />
    </Box>
  );
};
